import { render, staticRenderFns } from "./CertificateMappingCanvas.vue?vue&type=template&id=52646ff3&scoped=true&"
import script from "./CertificateMappingCanvas.vue?vue&type=script&lang=js&"
export * from "./CertificateMappingCanvas.vue?vue&type=script&lang=js&"
import style0 from "./CertificateMappingCanvas.vue?vue&type=style&index=0&id=52646ff3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52646ff3",
  null
  
)

export default component.exports